export type SoundNotificationType =
  | 'GENERAL'
  | 'CHAT_MESSAGE_RECEIVED'
  | 'CHAT_MESSAGE_SENT';

export const ALL_SOUND_NOTIFICATION_TYPES: SoundNotificationType[] = [
  'GENERAL',
  'CHAT_MESSAGE_RECEIVED',
  'CHAT_MESSAGE_SENT',
];

/**
 * Sound settings as returned by the API.
 * Contains the set of enabled sound notification types.
 */
export interface SoundSettings {
  soundNotifications: SoundNotificationType[];
}

export const DEFAULT_SOUND_SETTINGS: SoundSettings = {
  soundNotifications: [...ALL_SOUND_NOTIFICATION_TYPES],
};
